module.exports = __webpack_public_path__ + "img/background.b4ef7835.png";